import { render } from "./CoursView.vue?vue&type=template&id=277a375a&scoped=true"
import script from "./CoursView.vue?vue&type=script&lang=js"
export * from "./CoursView.vue?vue&type=script&lang=js"

import "./CoursView.vue?vue&type=style&index=0&id=277a375a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277a375a"]])

export default __exports__